<template>
  <div>
    <b-container>
      <b-row>
        <Login class="marginal" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
export default {
  components: {
    Login,
  },
};
</script>